import { render, staticRenderFns } from "./StatJewelry.vue?vue&type=template&id=3b223ed0&scoped=true&"
import script from "./StatJewelry.vue?vue&type=script&lang=js&"
export * from "./StatJewelry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b223ed0",
  null
  
)

export default component.exports